
import PropTypes from 'prop-types';

export default function OnboardingChecklist({
    completedSteps,
    steps
}) {

    return (
        <ul className="list-group onboarding-checklist">
            {steps.map((step) => (
                <li
                    key={step.id}
                    className={`list-group-item d-flex align-items-center ${completedSteps.includes(step.id) ? 'completed' : ''}`}
                >
                    <input
                        className="form-check-input me-2"
                        type="checkbox"
                        id={step.id}
                        checked={completedSteps.includes(step.id)}
                        readOnly={true}
                    />

                    <label className="form-check-label me-auto" htmlFor={step.id}>
                        <a href={step.link}>{step.label}</a>
                    </label>
                </li>
            ))}
        </ul>
    );

}

OnboardingChecklist.propTypes = {
    completedSteps: PropTypes.arrayOf(PropTypes.string).isRequired,
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired,
        })
    ).isRequired,
};
